module.exports = __webpack_public_path__ + "img/maps.1462c1bd.png";